import React, { useState } from 'react';
import { Check, Star, XIcon } from 'lucide-react';
import { WebinarMCStickyBar } from '../components/WebinarMCStickyBar';
export function WebinarMCPage() {
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  return <div className="min-h-screen bg-white font-sans text-gray-800" data-id="element-2463">
      {/* Registration Popup */}
      {isPopupOpen && <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 px-4" onClick={() => setIsPopupOpen(false)} data-id="element-2464">
          <div className="bg-white rounded-2xl p-6 w-full max-w-sm relative" onClick={e => e.stopPropagation()} data-id="element-2465">
            <button onClick={() => setIsPopupOpen(false)} className="absolute top-3 right-3 text-gray-400 hover:text-gray-600" data-id="element-2466">
              <XIcon className="w-6 h-6" data-id="element-2467" />
            </button>
            <div className="flex justify-center items-center w-full pt-4" data-id="element-2468">
              <iframe src="https://app.webinargeek.com/embed/5986c9f7-67ed-4239-8b16-51dc19c90478?cst=src-meta_cmp-mcc_pt-optin" height="500" width="330" title="Webinar Communiceren Met Je Hond Stressless Dogs" style={{
            border: 'none',
            borderRadius: '15px',
            backgroundColor: 'white',
            maxWidth: '100%'
          }} data-id="element-2469"></iframe>
            </div>
            <p className="text-xs text-gray-500 text-center mt-3" data-id="element-2470">
              We HATEN spam. Je e-mailadres is 100% veilig
            </p>
            <div className="flex items-center gap-3 mt-3 px-2" data-id="element-2471">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/kJ5b6tBbH8hDNt52JG84mT/Scherm%C2%ADafbeelding_2025-08-15_om_15.44.02.png" alt="Amee Buijs" className="w-9 h-9 rounded-full object-cover flex-shrink-0" data-id="element-2472" />
              <p className="text-xs text-gray-600 leading-snug" data-id="element-2473">
                Dit webinar wordt gegeven door Amee Buijs, honden
                gedragsdeskundige met 10 jaar ervaring.
              </p>
            </div>
          </div>
        </div>}

      {/* Navigation */}
      <nav className="w-full border-b border-gray-200 py-4 px-6 bg-white" data-id="element-2474">
        <div className="flex justify-center md:justify-between items-center" data-id="element-2475">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/6YKzftRpGkz4jKTtn8FQxB/Logo_Stressless_Dogs_%288%29_%284%29.png" alt="Stressless Dogs" className="h-10 object-contain" data-id="element-2476" />
          <div className="hidden md:block" data-id="element-2477">
            <div className="trustpilot-widget" data-locale="nl-NL" data-template-id="5419b6ffb0d04a076446a9af" data-businessunit-id="65017f0060003ffc450ac45e" data-style-height="20px" data-style-width="500px" data-theme="light" data-id="element-2478">
              <a href="https://nl.trustpilot.com/review/stresslessdogs.nl" target="_blank" rel="noopener noreferrer" data-id="element-2479">
                Trustpilot
              </a>
            </div>
          </div>
        </div>
        <div className="md:hidden flex justify-center mt-3 w-full" data-id="element-2480">
          <div className="trustpilot-widget" data-locale="nl-NL" data-template-id="5419b6ffb0d04a076446a9af" data-businessunit-id="65017f0060003ffc450ac45e" data-style-height="20px" data-style-width="100%" data-token="d24193a8-3943-4d9c-bcbd-f0b97f9d6fb9" data-id="element-2481">
            <a href="https://nl.trustpilot.com/review/stresslessdogs.nl" target="_blank" rel="noopener" data-id="element-2482">
              Trustpilot
            </a>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <section className="max-w-6xl mx-auto px-4 py-12 md:py-20 grid md:grid-cols-12 gap-12 items-center" data-id="element-2483">
        <div className="md:col-span-7" data-id="element-2484">
          <p className="text-sm font-bold text-gray-500 uppercase tracking-wider mb-4" data-id="element-2485">
            Gratis Online Webinar: Communiceren met je Hond
          </p>
          <h1 className="text-4xl md:text-5xl font-extrabold text-[#1a2b4a] mb-6 leading-tight" data-id="element-2486">
            Wat probeert je hond je te zeggen?
          </h1>
          <button onClick={() => setIsPopupOpen(true)} className="md:hidden mx-auto block bg-[#f27a6b] hover:bg-[#e0695a] text-white font-bold py-4 px-10 rounded-full text-lg transition-colors shadow-md mb-4" data-id="element-2487">
            Inschrijven webinar
          </button>
          <div className="md:hidden flex items-center justify-center gap-4 mb-8" data-id="element-2488">
            <div className="flex -space-x-3" data-id="element-2489">
              <img src="https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=100&h=100&fit=crop&crop=faces" className="w-10 h-10 rounded-full border-2 border-white" alt="User" data-id="element-2490" />
              <img src="https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=100&h=100&fit=crop&crop=faces" className="w-10 h-10 rounded-full border-2 border-white" alt="User" data-id="element-2491" />
              <img src="https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=100&h=100&fit=crop&crop=faces" className="w-10 h-10 rounded-full border-2 border-white" alt="User" data-id="element-2492" />
            </div>
            <div data-id="element-2493">
              <p className="font-bold text-lg text-[#1a2b4a]" data-id="element-2494">97.283+</p>
              <p className="text-xs text-gray-600" data-id="element-2495">
                Baasjes volgden al dit webinar
              </p>
            </div>
          </div>
          <p className="text-lg text-gray-700 mb-8 leading-relaxed" data-id="element-2496">
            Ontdek in dit gratis 90-minuten webinar de eenvoudige, liefdevolle
            methode die duizenden hondenbaasjes nu gebruiken om hun hond te
            begrijpen.
          </p>

          <ul className="space-y-4 mb-8" data-id="element-2497">
            {['Waarom je hond doet wat hij doet - en waarom je het tot nu toe verkeerd hebt begrepen', 'De taal van je hond - leer de signalen lezen van je hond zodat je ziet wat hij denkt, voelt en wilt', 'Wat angst, stress en onzekerheid werkelijk betekenen - en hoe je ze herkent', 'Waarom "ongehoorzaamheid" een mythe is - en hoe je zorgt dat jou hond weet wat je van hem wilt', 'Hoe je de wereld vanuit je hond ziet - zodat je "onverklaarbaar gedrag" ineens begrijpt', 'De 3 kernbehoeften van elke hond - en hoe deze je helpen om een rustigere blijere hond te krijgen'].map((item, i) => <li key={i} className="flex items-start" data-id="element-2498">
                <Check className="w-6 h-6 text-blue-500 mr-3 flex-shrink-0 mt-0.5" data-id="element-2499" />
                <span className="text-gray-700 font-medium" data-id="element-2500">{item}</span>
              </li>)}
          </ul>

          <div className="hidden md:flex items-center gap-4" data-id="element-2501">
            <div className="flex -space-x-3" data-id="element-2502">
              <img src="https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=100&h=100&fit=crop&crop=faces" className="w-12 h-12 rounded-full border-2 border-white" alt="User" data-id="element-2503" />
              <img src="https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=100&h=100&fit=crop&crop=faces" className="w-12 h-12 rounded-full border-2 border-white" alt="User" data-id="element-2504" />
              <img src="https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=100&h=100&fit=crop&crop=faces" className="w-12 h-12 rounded-full border-2 border-white" alt="User" data-id="element-2505" />
            </div>
            <div data-id="element-2506">
              <p className="font-bold text-xl text-[#1a2b4a]" data-id="element-2507">97.283+</p>
              <p className="text-sm text-gray-600" data-id="element-2508">
                Baasjes volgden al dit webinar
              </p>
            </div>
          </div>
        </div>

        <div className="md:col-span-5 flex justify-center" data-id="element-2509">
          <div className="p-6 rounded-3xl w-full max-w-sm mx-auto" data-id="element-2510">
            <div className="flex justify-center items-center w-full" data-id="element-2511">
              <iframe src="https://app.webinargeek.com/embed/5986c9f7-67ed-4239-8b16-51dc19c90478?cst=src-meta_cmp-mcc_pt-optin" height="550" width="330" title="Webinar Communiceren Met Je Hond Stressless Dogs" style={{
              border: 'none',
              borderRadius: '25px',
              backgroundColor: 'white',
              maxWidth: '100%'
            }} data-id="element-2512"></iframe>
            </div>
          </div>
        </div>
      </section>

      {/* 3 Steps Section */}
      <section className="bg-gray-50 py-20" data-id="element-2513">
        <div className="max-w-6xl mx-auto px-4 text-center" data-id="element-2514">
          <h2 className="text-3xl md:text-4xl font-bold text-[#1a2b4a] mb-16" data-id="element-2515">
            Leer de taal van je hond in drie stappen
          </h2>

          <div className="grid md:grid-cols-3 gap-12 mb-12" data-id="element-2516">
            <div className="flex flex-col items-center" data-id="element-2517">
              <img src="https://cdn.magicpatterns.com/uploads/7G3FddFkmDX1PP48Js3VUV/agenda_icon_(1).png" alt="Agenda icoon" className="w-32 h-32 object-contain mb-6" data-id="element-2518" />
              <h3 className="text-xl font-bold text-[#1a2b4a] mb-3" data-id="element-2519">Stap 1.</h3>
              <p className="text-gray-600" data-id="element-2520">
                Vul het formulier in en reserveer jouw plekje
              </p>
            </div>
            <div className="flex flex-col items-center" data-id="element-2521">
              <img src="https://cdn.magicpatterns.com/uploads/oxDbACMiW4Zh5cMbL7Ry7C/cursor_webinar_v3_(1).png" alt="Webinar knop icoon" className="w-32 h-32 object-contain mb-6" data-id="element-2522" />
              <h3 className="text-xl font-bold text-[#1a2b4a] mb-3" data-id="element-2523">Stap 2.</h3>
              <p className="text-gray-600" data-id="element-2524">
                Klik tegen die tijd op de link in je e-mail om direct deel te
                nemen
              </p>
            </div>
            <div className="flex flex-col items-center" data-id="element-2525">
              <img src="https://cdn.magicpatterns.com/uploads/swcfYXFhsSevmDxKpdEyU7/vrouw_hond_knuffel_(1).png" alt="Vrouw knuffelt hond" className="w-32 h-32 object-contain mb-6" data-id="element-2526" />
              <h3 className="text-xl font-bold text-[#1a2b4a] mb-3" data-id="element-2527">Stap 3.</h3>
              <p className="text-gray-600" data-id="element-2528">
                Leer in 90 minuten hoe je de taal van je hond leert spreken
              </p>
            </div>
          </div>

          <button onClick={() => setIsPopupOpen(true)} className="bg-[#f27a6b] hover:bg-[#e0695a] text-white font-bold py-4 px-10 rounded-full text-lg transition-colors shadow-md" data-id="element-2529">
            Inschrijven webinar
          </button>
        </div>
      </section>

      {/* Social Proof / Testimonials */}
      <section className="py-20 bg-[#fbfaf8]" data-id="element-2530">
        <div className="max-w-6xl mx-auto px-4 text-center" data-id="element-2531">
          <h2 className="text-3xl md:text-4xl font-bold text-[#1a2b4a] mb-16 max-w-3xl mx-auto leading-tight" data-id="element-2532">
            Duizenden baasjes gingen je voor - en zeggen allemaal hetzelfde:{' '}
            <br data-id="element-2533" />
            <span className="italic" data-id="element-2534">"Ik begrijp mijn hond nu pas echt."</span>
          </h2>

          {/* Videos */}
          <div className="grid md:grid-cols-3 gap-8 mb-16" data-id="element-2535">
            <div className="rounded-xl overflow-hidden shadow-lg bg-black" data-id="element-2536">
              <div style={{
              padding: '177.78% 0 0 0',
              position: 'relative'
            }} data-id="element-2537">
                <iframe src="https://player.vimeo.com/video/1086787571?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" frameBorder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media" style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%'
              }} title="MCC testimonial 2" data-id="element-2538"></iframe>
              </div>
            </div>
            <div className="rounded-xl overflow-hidden shadow-lg bg-black" data-id="element-2539">
              <div style={{
              padding: '177.78% 0 0 0',
              position: 'relative'
            }} data-id="element-2540">
                <iframe src="https://player.vimeo.com/video/1086787549?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" frameBorder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media" style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%'
              }} title="MCC testimonial 3" data-id="element-2541"></iframe>
              </div>
            </div>
            <div className="rounded-xl overflow-hidden shadow-lg bg-black" data-id="element-2542">
              <div style={{
              padding: '177.78% 0 0 0',
              position: 'relative'
            }} data-id="element-2543">
                <iframe src="https://player.vimeo.com/video/1086787601?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" frameBorder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media" style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%'
              }} title="MCC testimonial 1" data-id="element-2544"></iframe>
              </div>
            </div>
          </div>

          {/* Review Grid */}
          <div className="grid md:grid-cols-2 gap-6 mb-16 text-left" data-id="element-2545">
            <div className="bg-white border border-gray-200 rounded-lg p-6 shadow-sm" data-id="element-2546">
              <div className="flex items-center mb-4" data-id="element-2547">
                <div className="flex text-green-500 mr-2" data-id="element-2548">
                  {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-2549" />)}
                </div>
                <span className="text-sm text-gray-500" data-id="element-2550">8 jul 2024</span>
              </div>
              <h4 className="font-bold text-gray-900 mb-2" data-id="element-2551">
                Hele fijne cursus. Aanrader zelfs voor de ervaren honden
                liefhebber.
              </h4>
              <p className="text-gray-700 text-sm leading-relaxed" data-id="element-2552">
                Nu hebben wij altijd herplaatsers, dus we zijn wel wat gewend.
                Maar bij onze laatste herplaatser hebben we wel hulp nodig. In
                kort tijd nu al zoveel geleerd en handvaten gekregen. Ben enorm
                enthousiast over deze cursus en ik kreeg ook veel hulp
                aangeboden. Het is netjes overzichtelijk, duidelijk maar wat met
                het meeste aanspreekt is dat het zonder commando's gaat maar via
                communiceren.
              </p>
              <p className="text-sm font-semibold text-gray-900 mt-4" data-id="element-2553">
                - Nicolette
              </p>
            </div>

            <div className="bg-white border border-gray-200 rounded-lg p-6 shadow-sm" data-id="element-2554">
              <div className="flex items-center mb-4" data-id="element-2555">
                <div className="flex text-green-500 mr-2" data-id="element-2556">
                  {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-2557" />)}
                </div>
                <span className="text-sm text-gray-500" data-id="element-2558">3 sep 2024</span>
              </div>
              <h4 className="font-bold text-gray-900 mb-2" data-id="element-2559">
                Niet goed maar uitstekend!
              </h4>
              <p className="text-gray-700 text-sm leading-relaxed" data-id="element-2560">
                Amée is een zeer lieve vrouw met een hart voor honden en dat
                merk je zeer goed. De tips helpen echt. Ik raad iedereen met
                puppy's, jongere hondjes en alle andere leeftijden deze cursus
                aan, vooral mensen die problemen hebben met hun troetel. Zowel
                gedragsproblemen als medische problemen. Volg even de gratis
                Masterclass en je bent volledig overtuigd van de cursus en de
                mensen erachter. Heel veel liefs aan iedereen van het team.
              </p>
              <p className="text-sm font-semibold text-gray-900 mt-4" data-id="element-2561">
                - Tine Oetzmann
              </p>
            </div>

            <div className="bg-white border border-gray-200 rounded-lg p-6 shadow-sm" data-id="element-2562">
              <div className="flex items-center mb-4" data-id="element-2563">
                <div className="flex text-green-500 mr-2" data-id="element-2564">
                  {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-2565" />)}
                </div>
                <span className="text-sm text-gray-500" data-id="element-2566">20 apr 2024</span>
              </div>
              <h4 className="font-bold text-gray-900 mb-2" data-id="element-2567">
                Dit was de eerste keer dat ik een online hondencursus volgde...
              </h4>
              <p className="text-gray-700 text-sm leading-relaxed" data-id="element-2568">
                Dit was de eerste keer dat ik een online hondencursus volgde en
                ik heb er veel van opgestoken. Hoewel mijn honden zich (meestal)
                prima gedragen, wilde ik vooral leren wat ik zelf nog een beter
                kan doen ivm de communicatie. Dat is gelukt, het valt echt op
                dat omdat ik mij zelf anders opstel, mijn honden nu veel
                rustiger communiceren met andere honden. Vooral met onbekende
                honden was er toch vaak wel flink geblaf. Nu bijna niet meer,
                heerlijk, wat is wandelen toch/weer een genot. Idd: stressless!
              </p>
              <p className="text-sm font-semibold text-gray-900 mt-4" data-id="element-2569">
                - Margreet
              </p>
            </div>

            <div className="bg-white border border-gray-200 rounded-lg p-6 shadow-sm" data-id="element-2570">
              <div className="flex items-center mb-4" data-id="element-2571">
                <div className="flex text-green-500 mr-2" data-id="element-2572">
                  {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-2573" />)}
                </div>
                <span className="text-sm text-gray-500" data-id="element-2574">13 aug 2024</span>
              </div>
              <h4 className="font-bold text-gray-900 mb-2" data-id="element-2575">
                Ik vond het prettig mijn ervaring op te halen...
              </h4>
              <p className="text-gray-700 text-sm leading-relaxed" data-id="element-2576">
                Ik vond het prettig mijn ervaring op te halen en voorbereid te
                zijn op de puppy die ik al snel krijg. Goed gewerkt!
              </p>
              <p className="text-sm font-semibold text-gray-900 mt-4" data-id="element-2577">
                - Henne Buskermolen
              </p>
            </div>
          </div>

          <button onClick={() => setIsPopupOpen(true)} className="bg-[#f27a6b] hover:bg-[#e0695a] text-white font-bold py-4 px-10 rounded-full text-lg transition-colors shadow-md" data-id="element-2578">
            Inschrijven webinar
          </button>
        </div>
      </section>

      {/* About Amee */}
      <section className="py-20 bg-white" data-id="element-2579">
        <div className="max-w-5xl mx-auto px-4 grid md:grid-cols-2 gap-12 items-center" data-id="element-2580">
          <div data-id="element-2581">
            <h2 className="text-3xl md:text-4xl font-bold text-[#1a2b4a] mb-6 leading-tight" data-id="element-2582">
              Hoi, ik ben Amee en ik geef dit webinar.
            </h2>
            <div className="space-y-4 text-gray-700 leading-relaxed" data-id="element-2583">
              <p data-id="element-2584">
                Ik ben Amee de Bruijn, hondengedragsdeskundige en oprichter van
                StresslessDogs.nl. Maar veel belangrijker: ik ben iemand die
                precies begrijpt wat je voelt als je hond je frustreert en je
                niet weet hoe je hem beter kunt begrijpen.
              </p>
              <p data-id="element-2585">
                In de afgelopen jaren heb ik meer dan 15.000 hondenbaasjes en
                hun honden mogen begeleiden. Niet om hen te 'trainen' in de
                traditionele zin, maar om hen te helpen wat ik zelf ook ontdekt
                heb: dat echte verandering begint met communicatie, niet met
                commando's.
              </p>
              <p data-id="element-2586">
                Wat ik in al die jaren heb gezien, is dat de meeste frustratie
                niet voortkomt uit een 'slecht' hond of een 'falende' baas. Het
                komt voort uit onbegrip. Uit het feit dat baasjes en honden
                letterlijk twee verschillende talen spreken. Zodra je die taal
                van je hond leert, verdwijnt de frustratie. De strijd maakt
                plaats voor samenwerking. En de band wordt onverwoestbaar.
              </p>
              <p data-id="element-2587">
                Daarom werk ik uitsluitend met methodes die gebaseerd zijn op
                vertrouwen, veiligheid, wederzijds respect en echte
                communicatie. Geen dwang, geen pijn, geen angst, geen straf.
                Alleen liefde en begrip. Want dat is wat zowel jij als je hond
                verdienen.
              </p>
              <p data-id="element-2588">
                Dit webinar is mijn manier om dit geheim met zoveel mogelijk
                hondenbaasjes te delen. Omdat ik geloof dat elke hond en elke
                mens de kans verdient om elkaar écht te begrijpen.
              </p>
            </div>
          </div>
          <div className="rounded-2xl overflow-hidden shadow-xl" data-id="element-2589">
            <img src="https://cdn.magicpatterns.com/uploads/vXmyJc5cCVvbLnBaXGCixn/682f298cbb713_AmeemetSophietje1.png" alt="Amee met Sophietje" className="w-full h-auto object-cover" data-id="element-2590" />
          </div>
        </div>
      </section>

      {/* Bottom Registration */}
      <section className="py-20 bg-gray-50" data-id="element-2591">
        <div className="max-w-md mx-auto px-4" data-id="element-2592">
          <div className="p-6 rounded-3xl w-full" data-id="element-2593">
            <div className="flex justify-center items-center" data-id="element-2594">
              <iframe src="https://app.webinargeek.com/embed/5986c9f7-67ed-4239-8b16-51dc19c90478?cst=src-meta_cmp-mcc_pt-optin" height="550" width="330" title="Webinar Communiceren Met Je Hond Stressless Dogs" style={{
              border: 'none',
              borderRadius: '25px',
              backgroundColor: 'white'
            }} data-id="element-2595"></iframe>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-white border-t border-gray-200 py-12" data-id="element-2596">
        <div className="max-w-6xl mx-auto px-4 flex flex-col items-center text-center" data-id="element-2597">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/6YKzftRpGkz4jKTtn8FQxB/Logo_Stressless_Dogs_%288%29_%284%29.png" alt="Stressless Dogs" className="h-12 object-contain mb-6" data-id="element-2598" />
          <p className="font-semibold text-[#1a2b4a] mb-2" data-id="element-2599">
            Voor liefdevolle hondenbaasjes
          </p>
          <a href="mailto:amee@stresslessdogs.nl" className="text-blue-600 hover:underline mb-8" data-id="element-2600">
            amee@stresslessdogs.nl
          </a>

          <div className="text-xs text-gray-500 max-w-3xl leading-relaxed" data-id="element-2601">
            <p className="mb-2" data-id="element-2602">
              © 2025 Stressless Dogs. Alle rechten voorbehouden.
            </p>
            <p data-id="element-2603">
              Deze website maakt gebruik van cookies en vergelijkbare
              technologieën voor analytische en advertentiedoeleinden. Deze
              pagina is een advertorial voor Stressless Dogs. Stressless Dogs is
              een onafhankelijk bedrijf en is op geen enkele wijze verbonden aan
              of onderdeel van Meta (voorheen Facebook). Deze advertentie wordt
              getoond via het Meta advertentieplatform, maar Meta is niet
              verantwoordelijk voor de inhoud of diensten aangeboden door
              Stressless Dogs.
            </p>
          </div>
        </div>
      </footer>
      <WebinarMCStickyBar onClickCTA={() => setIsPopupOpen(true)} data-id="element-2604" />
    </div>;
}